import { render, staticRenderFns } from "./DonutChartV2.vue?vue&type=template&id=2a43f633&scoped=true"
import script from "./DonutChartV2.vue?vue&type=script&lang=js"
export * from "./DonutChartV2.vue?vue&type=script&lang=js"
import style0 from "./DonutChartV2.vue?vue&type=style&index=0&id=2a43f633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a43f633",
  null
  
)

export default component.exports